module.exports = __webpack_public_path__ + "static/banner-4-81f7cef20a1b8d83f5865be915d5a3e5.jpg";